import { useEffect, useState } from 'react'
import { useAppDispatch } from 'store/hooks'
import Calculator from 'components/ui/account/loan-calculator'
import { fetchLoans } from 'store/reducers/loans'

import styles from './styles.module.scss'

export default function NewLoan() {
  const [isCurrenciesUpdated, setIsCurrenciesUpdated] = useState(false)
  const dispatch = useAppDispatch()

  useEffect(() => {
    setTimeout(() => {
      dispatch(fetchLoans())
      setIsCurrenciesUpdated(true)
    }, 0)
  }, [])

  return (
    <div className={styles.container}>
      <Calculator isCurrenciesUpdated={isCurrenciesUpdated} />
    </div>
  )
}
